module.exports = __webpack_public_path__ + "504ec3c7e7225d6c613793f03fb83831.svg";